import React, {memo} from "react";
import {CustomTooltip} from "components/CustomTooltip";
import cn from "classnames";

const wrapperClass = "wdth-20 hght-20 white fz-10 __bold __uppercase df-row-jcc-center";

export const IconCheckpoint = memo(({name, tooltip, color = "#000", addClass}) => (
  <CustomTooltip text={tooltip}>
    <div
      className={cn(wrapperClass, {[addClass]: !!addClass})}
      style={{backgroundColor: color, borderRadius: "2px"}}
    >
      {name}
    </div>
  </CustomTooltip>
));
